import { FC, useMemo } from 'react'
import {
    CardWrapper,
    SummaryCardImg,
    SummaryInfo,
    SummaryInfoListWrapper,
    InfoTitle,
    SummaryInfoPrice,
    SummaryInfoLabel,
    SummaryInfoValue
} from './styles'
import { Endpoints } from '@brg/api'
import SummaryTable from '../SummaryTable'
import {MagicBox, useBreakpoint, useIsMobile, useResizedImage} from '@brg/ui'
import { useSelector } from 'react-redux'
import { getCurrentAppName, getCurrentContextName } from 'supporting'
import { LayoutConst } from 'core'
import { useTranslation } from 'react-i18next'
import {LeftGridText, ProductNameWrapper} from '../SummaryTable/styles'
import { selectorOrder } from "../../slices/OrderSlice";
import { EntityPaymentTypes } from "../../constants/payment";
import { Product } from "../../constants/types";
import { isServer } from 'shared/constants/isServer';
const CardComponent = isServer ? {} : require('adaptive-cards');

interface SummaryInfoItemProps {
    product: Product | any
    info?: { [key: string]: string }
    calendarCardsToBuy?: any[]
    calendarFullData?: any
    totalPrice?: any
    currencyIcon?: any
    paymentSuccess?: boolean
}

const dw = [26.2, 38.0]
const dh = [37, 28.5]

// const dw1440 = [26.2, 26.2]
const dw1440 = [26.2, 38.0]
// const dh1440 = [37, 21.9]
const dh1440 = [37, 28.5]


const dwMob = [26.2, 35.0]
// const dhMob = [37, 26]
const dhMob = [37, 26]

export const SummaryInfoItem: FC<SummaryInfoItemProps> = ({ product, info = {}, calendarCardsToBuy, calendarFullData, totalPrice, currencyIcon, paymentSuccess }) => {
    const isMobile = useBreakpoint(LayoutConst.screen.s)
    const is1440BP = useBreakpoint(1440)
    const is1200BP = useBreakpoint(1200)


    const isCalendar = product.preview === "calendar"
    const isBook = product?.type === EntityPaymentTypes.book
    const productImages = product?.preview === "calendar" ? [] :
        product?.preview ? product.preview :
            product?.images ? product.images : []
    const [img, containerRef] = useResizedImage(productImages)
    const order = useSelector(selectorOrder)
    const contextName = getCurrentContextName()
    const isZeland = contextName === 'zeland';
    const isCard = product?.cardInfo
    const appName = getCurrentAppName()
    const isHorizontal = product?.cardInfo?.templateType?.orientation === "horizontal"
    const templateType = product?.cardInfo?.templateType?.nameComponent ||
        (isZeland ? 'LuvrikCardA4' : 'WarholCardA4') + (isHorizontal ? 'L' : '')

    const adaptiveDw = useMemo(() => isMobile ? dwMob[+isHorizontal] : is1440BP ? dw1440[+isHorizontal] : dw[+isHorizontal], [isMobile, is1440BP, isHorizontal])
    const adaptiveDh = useMemo(() => isMobile ? dhMob[+isHorizontal] : is1440BP ? dh1440[+isHorizontal] : dh[+isHorizontal], [isMobile, is1440BP, isHorizontal])
    const { t } = useTranslation()

    // @ts-ignore
    const pricePdf = order?.availableCurrencies?.[0]?.templatePrice;
    // @ts-ignore
    const priceCard = order?.availableCurrencies?.[0]?.cardsPrice;

    const getProductName = () => {
        if (isCalendar) return product?.name
        if (typeof product?.name === "string") return product?.name
        return product?.name?.[0]?.name || "Unnamed product"

    }

    return (
        <>
            <SummaryInfo ref={containerRef}>
                {isBook ?
                    <SummaryCardImg src={Endpoints.files + "/" + img?.url} />
                    : isCard
                        ?
                        <>
                            {/* @ts-ignore */}
                            <CardWrapper isHorizontal={isHorizontal}>
                                <CardComponent.MasterCard
                                    data={product}
                                    image={Endpoints.files + '/' + img?.url}
                                    templateType={templateType}
                                    appName={appName || 'gallllery'}
                                    contextName={contextName || 'zeland'}
                                    dw={adaptiveDw}
                                    dh={adaptiveDh}
                                />
                            </CardWrapper>
                        </>
                        : <SummaryCardImg src={Endpoints.files + "/" + img?.url} />
                }

                {!is1200BP &&
                    <div>
                        <MagicBox gy={4} direction="column" directionMobile="column" offsetBottom={isBook ? 16 : 0}>
                            <InfoTitle receiveGift textV1 noMarginBottom={isBook}>{getProductName()}</InfoTitle>
                            {isBook && <LeftGridText>{t('payment.e_book')}</LeftGridText>}
                        </MagicBox>
                        {(isBook || !isCard) ? <SummaryTable paymentSuccess={paymentSuccess} product={product} info={info} cardsToBuy={isBook ? product?.cardInfo : calendarCardsToBuy} /> :
                            <SummaryTable paymentSuccess={paymentSuccess} product={product} info={info} isCard={(isBook || !isCard)} />
                        }
                    </div>}
                {is1200BP && <ProductNameWrapper>{getProductName()}</ProductNameWrapper>}
            </SummaryInfo>

            {is1200BP &&
                <div>
                    {(isBook || !isCard) ? <SummaryTable paymentSuccess={paymentSuccess} product={product} info={info} cardsToBuy={isBook ? product?.cardInfo : calendarCardsToBuy} /> :
                        <SummaryTable paymentSuccess={paymentSuccess} product={product} info={info} />
                    }
                </div>}

            {isCalendar && <SummaryInfoPrice>
                <SummaryInfoLabel>{t("payment.cards")}</SummaryInfoLabel>
                <SummaryInfoValue>{priceCard}{currencyIcon}</SummaryInfoValue>
                <SummaryInfoLabel>{t("payment.PDF")}</SummaryInfoLabel>
                <SummaryInfoValue>{pricePdf}{currencyIcon}</SummaryInfoValue>
            </SummaryInfoPrice>}
        </>

    )
}

interface SummaryInfoListProps {
    offsetBottom?: number
    offsetTop?: number
    paymentSuccess?: boolean
    paymentCurrency?: any
    complexTotalComponent?: any
}

export const SummaryInfoList: FC<SummaryInfoListProps> = ({ offsetBottom, offsetTop, paymentCurrency, paymentSuccess }) => {
    const isMobile = useIsMobile()
    const order = useSelector(selectorOrder)

    return (
        <SummaryInfoListWrapper offsetBottom={offsetBottom} offsetTop={offsetTop} mobile={isMobile}>
            {
                order?.products?.map(product => (
                    <SummaryInfoItem info={product.summary} key={product.id} product={product} paymentSuccess={paymentSuccess} />
                ))
            }
        </SummaryInfoListWrapper>
    )
}
import { FC, useMemo } from 'react'
import {
    CardWrapper,
    SummaryCardImg,
    SummaryInfo,
    SummaryInfoListWrapper,
    InfoTitle,
    SummaryInfoPrice,
    SummaryInfoLabel,
    SummaryInfoValue
} from './styles'
import { Endpoints } from '@brg/api'
import SummaryTable from '../SummaryTable'
import {MagicBox, useBreakpoint, useIsMobile, useResizedImage} from '@brg/ui'
import { useSelector } from 'react-redux'
import { getCurrentAppName, getCurrentContextName } from 'supporting'
import { LayoutConst } from 'core'
import { useTranslation } from 'react-i18next'
import {LeftGridText, ProductNameWrapper} from '../SummaryTable/styles'
import { selectorOrder } from "../../slices/OrderSlice";
import { EntityPaymentTypes } from "../../constants/payment";
import { Product } from "../../constants/types";
import { isServer } from 'shared/constants/isServer';
const CardComponent = isServer ? {} : require('adaptive-cards');

interface SummaryInfoItemProps {
    product: Product | any
    info?: { [key: string]: string }
    calendarCardsToBuy?: any[]
    calendarFullData?: any
    totalPrice?: any
    currencyIcon?: any
    paymentSuccess?: boolean
}

const dw = [26.2, 38.0]
const dh = [37, 28.5]

// const dw1440 = [26.2, 26.2]
const dw1440 = [26.2, 38.0]
// const dh1440 = [37, 21.9]
const dh1440 = [37, 28.5]


const dwMob = [26.2, 35.0]
// const dhMob = [37, 26]
const dhMob = [37, 26]

export const SummaryInfoItem: FC<SummaryInfoItemProps> = ({ product, info = {}, calendarCardsToBuy, calendarFullData, totalPrice, currencyIcon, paymentSuccess }) => {
    const isMobile = useBreakpoint(LayoutConst.screen.s)
    const is1440BP = useBreakpoint(1440)
    const is1200BP = useBreakpoint(1200)


    const isCalendar = product.preview === "calendar"
    const isBook = product?.type === EntityPaymentTypes.book
    const productImages = product?.preview === "calendar" ? [] :
        product?.preview ? product.preview :
            product?.images ? product.images : []
    const [img, containerRef] = useResizedImage(productImages)
    const order = useSelector(selectorOrder)
    const contextName = getCurrentContextName()
    const isZeland = contextName === 'zeland';
    const isCard = product?.cardInfo
    const appName = getCurrentAppName()
    const isHorizontal = product?.cardInfo?.templateType?.orientation === "horizontal"
    const templateType = product?.cardInfo?.templateType?.nameComponent ||
        (isZeland ? 'LuvrikCardA4' : 'WarholCardA4') + (isHorizontal ? 'L' : '')

    const adaptiveDw = useMemo(() => isMobile ? dwMob[+isHorizontal] : is1440BP ? dw1440[+isHorizontal] : dw[+isHorizontal], [isMobile, is1440BP, isHorizontal])
    const adaptiveDh = useMemo(() => isMobile ? dhMob[+isHorizontal] : is1440BP ? dh1440[+isHorizontal] : dh[+isHorizontal], [isMobile, is1440BP, isHorizontal])
    const { t } = useTranslation()

    // @ts-ignore
    const pricePdf = order?.availableCurrencies?.[0]?.templatePrice;
    // @ts-ignore
    const priceCard = order?.availableCurrencies?.[0]?.cardsPrice;

    const getProductName = () => {
        if (isCalendar) return product?.name
        if (typeof product?.name === "string") return product?.name
        return product?.name?.[0]?.name || "Unnamed product"

    }

    return (
        <>
            <SummaryInfo ref={containerRef}>
                {isBook ?
                    <SummaryCardImg src={Endpoints.files + "/" + img?.url} />
                    : isCard
                        ?
                        <>
                            {/* @ts-ignore */}
                            <CardWrapper isHorizontal={isHorizontal}>
                                <CardComponent.MasterCard
                                    data={product}
                                    image={Endpoints.files + '/' + img?.url}
                                    templateType={templateType}
                                    appName={appName || 'gallllery'}
                                    contextName={contextName || 'zeland'}
                                    dw={adaptiveDw}
                                    dh={adaptiveDh}
                                />
                            </CardWrapper>
                        </>
                        : <SummaryCardImg src={Endpoints.files + "/" + img?.url} />
                }

                {!is1200BP &&
                    <div>
                        <MagicBox gy={4} direction="column" directionMobile="column" offsetBottom={isBook ? 16 : 0}>
                            <InfoTitle receiveGift textV1 noMarginBottom={isBook}>{getProductName()}</InfoTitle>
                            {isBook && <LeftGridText>{t('payment.e_book')}</LeftGridText>}
                        </MagicBox>
                        {(isBook || !isCard) ? <SummaryTable paymentSuccess={paymentSuccess} product={product} info={info} cardsToBuy={isBook ? product?.cardInfo : calendarCardsToBuy} /> :
                            <SummaryTable paymentSuccess={paymentSuccess} product={product} info={info} isCard={(isBook || !isCard)} />
                        }
                    </div>}
                {is1200BP && <ProductNameWrapper>{getProductName()}</ProductNameWrapper>}
            </SummaryInfo>

            {is1200BP &&
                <div>
                    {(isBook || !isCard) ? <SummaryTable paymentSuccess={paymentSuccess} product={product} info={info} cardsToBuy={isBook ? product?.cardInfo : calendarCardsToBuy} /> :
                        <SummaryTable paymentSuccess={paymentSuccess} product={product} info={info} />
                    }
                </div>}

            {isCalendar && <SummaryInfoPrice>
                <SummaryInfoLabel>{t("payment.cards")}</SummaryInfoLabel>
                <SummaryInfoValue>{priceCard}{currencyIcon}</SummaryInfoValue>
                <SummaryInfoLabel>{t("payment.PDF")}</SummaryInfoLabel>
                <SummaryInfoValue>{pricePdf}{currencyIcon}</SummaryInfoValue>
            </SummaryInfoPrice>}
        </>

    )
}

interface SummaryInfoListProps {
    offsetBottom?: number
    offsetTop?: number
    paymentSuccess?: boolean
    paymentCurrency?: any
    complexTotalComponent?: any
}

export const SummaryInfoList: FC<SummaryInfoListProps> = ({ offsetBottom, offsetTop, paymentCurrency, paymentSuccess }) => {
    const isMobile = useIsMobile()
    const order = useSelector(selectorOrder)

    return (
        <SummaryInfoListWrapper offsetBottom={offsetBottom} offsetTop={offsetTop} mobile={isMobile}>
            {
                order?.products?.map(product => (
                    <SummaryInfoItem info={product.summary} key={product.id} product={product} paymentSuccess={paymentSuccess} />
                ))
            }
        </SummaryInfoListWrapper>
    )
}
